import { FormLabel as ChakraFormLabel } from '@chakra-ui/react';

type FormLabelProps = React.ComponentProps<typeof ChakraFormLabel>;

const FormLabel = ({ children, ...props }: Readonly<FormLabelProps>) => {
  return <ChakraFormLabel {...props}>{children}</ChakraFormLabel>;
};

export default FormLabel;
